module.exports = __webpack_public_path__ + "img/5.1960e2ca.png";